var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['stock-level-status', { 'stock-level-status--online': _vm.isOnline }]},[_vm._v(" "+_vm._s(_vm.$t(_vm.stockLevelStatus))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }